import {useTranslation} from "react-i18next";

export const ContactUs = ({ email }: { email?: string }) => {
  const { t } = useTranslation();

  if(!email){
    return <></>;
  }

  return <div className="text-sm text-foreground mt-8 text-center space-y-2">
    {email && (
      <>
        <p>
          {t("fe.pages.login.questions")} {" "}
          {t("fe.pages.login.contactUs")}
        </p>
        <div className="flex items-center justify-center gap-2">
          <a
            href={`mailto:${email}`}
            className="text-primary font-medium hover:underline underline-offset-2"
          >
            {email}
          </a>
        </div>
      </>
    )}
  </div>
};
